import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as FacebookIcon } from '../../assets/images/icons/facebook-icon.svg';
import { ReactComponent as LinkedInIcon } from '../../assets/images/icons/linkedin-icon.svg';
import { ReactComponent as XIcon } from '../../assets/images/icons/x-icon.svg';
import { ReactComponent as InstagramIcon } from '../../assets/images/icons/instagram-icon.svg';
import { SOCIAL_FACEBOOK_URL, SOCIAL_LINKEDIN_URL, SOCIAL_X_URL, SOCIAL_INSTAGRAM_URL} from '../../config/constants';

import './style.scss';

const SocialsList = () => {

  const { t } = useTranslation();
  

  return (
    <div className="socialsList row justify-content-center">
      <div className="socialsList__inner">
        <h4>{t('socials_list_title')}</h4>
        <ul className="socialsList__list row justify-content-between">
          {SOCIAL_FACEBOOK_URL && <li className="socialsList__item"><a href={SOCIAL_FACEBOOK_URL}><FacebookIcon/><span className="sr-only">{t('socials_list_facebook_link_text')}</span></a></li>}
          {SOCIAL_LINKEDIN_URL && <li className="socialsList__item"><a href={SOCIAL_LINKEDIN_URL}><LinkedInIcon/><span className="sr-only">{t('socials_list_linkedin_link_text')}</span></a></li>}
          {SOCIAL_X_URL && <li className="socialsList__item"><a href={SOCIAL_X_URL}><XIcon/><span className="sr-only">{t('socials_list_x_link_text')}</span></a></li>}
          {SOCIAL_INSTAGRAM_URL && <li className="socialsList__item"><a href={SOCIAL_INSTAGRAM_URL}><InstagramIcon/><span className="sr-only">{t('socials_list_instagram_link_text')}</span></a></li>}
        </ul>
      </div>
    </div>
  );
};

export default SocialsList;
